import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { BuyerAccountPointsService } from '../services/buyer-account-points.service';

const buyerPointsService = DiContainer.get(BuyerAccountPointsService);

const setBuyerPoints = createEvent();
const setBuyerPointsLoadingStatus = createEvent<{
  loading: boolean;
  error: string | boolean | Error;
}>();

export const $buyerPointsLoadingStatus = createStore<{
  loading: boolean;
  error: string | boolean | Error;
}>({ loading: false, error: false }).on(setBuyerPointsLoadingStatus, (_s, p) => p);

export const $buyerPoints = createStore<any>(null).on(setBuyerPoints, (_s, p) => p);
export const fetchBuyerPointsFx = createEffect(async () => {
  try {
    setBuyerPointsLoadingStatus({ loading: true, error: false });
    const res = await buyerPointsService.getAllPointsInfo();
    setBuyerPointsLoadingStatus({ loading: false, error: false });
    return res;
  } catch (err) {
    setBuyerPointsLoadingStatus({ loading: false, error: err as Error });
  }
});

sample({
  target: setBuyerPoints,
  clock: fetchBuyerPointsFx.doneData,
});

export const updateBuyerPointFx = createEffect(async (dto: any) => {
  const res = await buyerPointsService.updatePointInfo(dto);
  return res;
});

export const createBuyerPointFx = createEffect(async (dto: any) => {
  const res = await buyerPointsService.createNewPoint(dto);
  return res;
});

export const deleteBuyerPointFx = createEffect(async (id: number) => {
  const res = await buyerPointsService.deletePoint(id);
  return res;
});

export const switchBuyerPointFx = createEffect(async ({id, enabled}: {id: number, enabled: 1 | 0}) => {
  try {
    const res = await buyerPointsService.switchBuyerPoint({ id, enabled });
    return res;
  } catch (err: any) {
    const errorBody = err.headers ? await err.json() : null;
    throw errorBody || err;
  }
});
